function getAccountTypeLabel(accountType: string): string {
  const types = {
    bankBoxOffice: 'Retiro en efectivo',
    Checking: 'Cuenta corriente',
    RUT: 'Cuenta RUT',
    Saving: 'Cuenta de ahorros',
    Vista: 'Cuenta vista',
  };
  return types[accountType];
}

export default getAccountTypeLabel;
